import { takeEvery, call } from 'redux-saga/effects';
import axios from 'axios';
import Config from '@/Config';
import ActionType from '@/actions/action-type';
import { IReceiveOrder } from '@/actions/good-received-note-actions';
import {
  ICreateReturnNote,
  IQueryReturnNoteDetail,
  ICancelReturnNote,
  IReceiveReturnNote,
  IQueryReturnNotes,
} from '@/actions/return-note-action';
import { parseGoodReceivedNote } from '@/utils/good-received-note-utill';

function* handleCreateReturnNote(params: ICreateReturnNote) {
  const { storeID, returnNote, callback } = params;
  let newGoodReceivedNote: IReceiveOrder | undefined = undefined;
  let returnReceiveOrder: any = '';
  try {
    const receiveOrderItems = getReceiveOrderItems(returnNote);
    const receiveOrder = {
      'receive_order': {
        'purchase_order_ids': returnNote.purchaseOrderIDs,
        'note_type': 2,
        'unit_enable': true,
        'store_id': storeID,
        'supplier_id': returnNote.supplierID,
        'supplier_name': returnNote.supplierName,
        'expected_receive_date': returnNote.expectedReceiveDate,
        'reference_number': returnNote.referenceNumber,
        'remarks': returnNote.remarks,
      },
      'receive_order_items': receiveOrderItems
    }
    console.info(receiveOrder)
    const resp = yield axios({
      method: 'POST',
      url: Config.urls.createReceiveOrder.replace('{storeID}', storeID),
      data: receiveOrder,
      headers: {
        'x-user-device-type': 'pos',
      }
    })
    if (resp && resp['receive_order']) {
      const goodsReceiveOrderEdit = returnNote

      if (goodsReceiveOrderEdit.purchaseOrderIDs.length > 0) {
        const purchaseOrderIDs: string[] = [];
        goodsReceiveOrderEdit.purchaseOrderIDs.forEach(item => {
          purchaseOrderIDs.push(`${item}`)
        })
      }
      const newGoodsReceiveOrder = parseGoodReceivedNote(resp['receive_order']);
      const purchaseItemToReceiveOrderItemID: {[purchaseItemID: number]: {qtyReceived: number; qtyRemaining: number; qtyReceivedPO: number; qtyPO: number; qtyReceive: number}} = {};
      goodsReceiveOrderEdit.purchaseOrders.forEach(item => {
        item.lineItems.forEach(lineItem => {
          purchaseItemToReceiveOrderItemID[lineItem.purchaseItemID] = {
            qtyReceived: lineItem.qtyReceived,
            qtyRemaining: lineItem.qtyRemaining,
            qtyReceivedPO: lineItem.qtyReceivedPO,
            qtyPO: lineItem.qtyPO,
            qtyReceive: lineItem.qtyReceive,
          }
        })
      })
      console.info(goodsReceiveOrderEdit)
      console.info(purchaseItemToReceiveOrderItemID)
      newGoodsReceiveOrder.purchaseOrders.forEach(item => {
        item.lineItems.forEach(lineItem => {
          if (purchaseItemToReceiveOrderItemID[lineItem.purchaseItemID]) {
            const purchaseItem = purchaseItemToReceiveOrderItemID[lineItem.purchaseItemID];
            lineItem.qtyReceived = purchaseItem.qtyReceived
            lineItem.qtyRemaining = purchaseItem.qtyRemaining
            lineItem.qtyReceivedPO = purchaseItem.qtyReceivedPO
            lineItem.qtyReceive = purchaseItem.qtyReceive
            lineItem.qtyPO = purchaseItem.qtyPO
          }
        })
      })

      const receiveOrderItems = getReceiveOrderItems(newGoodsReceiveOrder);
      const newReceiveOrder = {
        'receive_order': {
          'id': resp['receive_order']['id'],
          'user_id': resp['receive_order']['user_id'],
          'created_by': resp['receive_order']['created_by'],
          'number': resp['receive_order']['number'],
          'reference_number': newGoodsReceiveOrder.referenceNumber,
          'receive_date': resp['receive_order']['receive_date'],
          'purchase_order_id': resp['receive_order']['purchase_order_id'],
          'state': newGoodsReceiveOrder.state,
          'remarks': newGoodsReceiveOrder.remarks,
          'created_at': newGoodsReceiveOrder.createdAt,
          'updated_at': resp['receive_order']['updated_at'],
          'canceled_at': resp['receive_order']['canceled_at'],
          'stock_transfers': resp['receive_order']['stock_transfers'],
          'state_for_display': resp['receive_order']['state_for_display'],
          'expected_receive_date': newGoodsReceiveOrder.expectedReceiveDate,
          'purchase_order_ids': newGoodsReceiveOrder.purchaseOrderIDs,
          'note_type': 2,
          'unit_enable': resp['receive_order']['unit_enable'],
          'store_id': storeID,
          'supplier_id': newGoodsReceiveOrder.supplierID,
          'supplier_name': newGoodsReceiveOrder.supplierName,
        },
        'receive_order_items': receiveOrderItems
      }
      const res = yield axios({
        method: 'PUT',
        url: Config.urls.getReceiveOrder.replace('{storeID}', storeID).replace('{receiveOrderID}', resp['receive_order']['id']),
        data: newReceiveOrder,
        headers: {
          'x-user-device-type': 'pos',
        }
      })

      if (res && res['receive_order']) {
        returnReceiveOrder = res['receive_order'];
        newGoodReceivedNote = parseGoodReceivedNote(res['receive_order']);
      }
    }
  } catch (error) {
    console.error(error);
  }
  if (callback) {
    console.info(newGoodReceivedNote);
    callback(newGoodReceivedNote);
  }

  return returnReceiveOrder;
}

function* handleQueryReturnNotes(params: IQueryReturnNotes) {
  const { storeID, page, callback } = params;
  const returnNotes: IReceiveOrder[] = [];
  const listingIDs: string[] = [];
  const listings: {[id: string]: any} = {};
  let ids = '';

  try {
    const res = yield call(
      axios.get,
      Config.urls.getReceiveOrders.replace('{storeID}', storeID).replace('{page}', page.toString()).replace('{noteType}', '2'),
    )
    if (res && res.receive_orders) {
      const receiveOrders = res.receive_orders;
      if (Array.isArray(receiveOrders)) {
        receiveOrders.forEach(receiveOrder => {
          if (receiveOrder['receive_order_items'] && Array.isArray(receiveOrder['receive_order_items'])) {
            receiveOrder['receive_order_items'].forEach(item => {
              if (item['receive_order_item'] && item['receive_order_item']['purchase_item'] && item['receive_order_item']['purchase_item']['source_type'] === 'Listing' && item['receive_order_item']['purchase_item']['source_id'] && !listingIDs.includes(item['receive_order_item']['purchase_item']['source_id'])) {
                listingIDs.push(item['receive_order_item']['purchase_item']['source_id']);
                if (ids) {
                  ids += `&ids[]=${item['receive_order_item']['purchase_item']['source_id']}`;
                } else {
                  ids = `?ids[]=${item['receive_order_item']['purchase_item']['source_id']}`;
                }
              }
            })
          }
        })
        const listingInfo = yield call(
          axios.get,
          Config.urls.getListings.replace('{storeID}', storeID).replace('{ids}', ids),
        );
        if (listingInfo && Array.isArray(listingInfo.listings)) {
          listingInfo.listings.forEach((listing: any) => {
            if (listing['id']) {
              listings[listing['id']] = listing;
            }
          })
        }
        receiveOrders.forEach(receiveOrder => {
          if (receiveOrder['receive_order_items'] && Array.isArray(receiveOrder['receive_order_items'])) {
            receiveOrder['receive_order_items'].forEach(item => {
              if (item['receive_order_item'] && item['receive_order_item']['purchase_item'] && item['receive_order_item']['purchase_item']['source_id']) {
                item['receive_order_item']['purchase_item']['listing'] = listings[item['receive_order_item']['purchase_item']['source_id']]
              }
            })
            returnNotes.push(parseGoodReceivedNote(receiveOrder));
          }
        })
        
      }
      
    }
  } catch (error) {
    console.error(error);
  }
  if (callback) {
    callback(returnNotes)
  }
}

function* handleQueryReturnNote(params: IQueryReturnNoteDetail) {
  const { receiveOrderID, callback, storeID } = params;
  let returnNote: IReceiveOrder | undefined = undefined;
  const listingIDs: string[] = [];
  const listings: {[id: string]: any} = {};
  let ids = '';
  try {
    const res = yield call(
      axios.get,
      Config.urls.getReceiveOrder.replace('{storeID}', storeID).replace('{receiveOrderID}', receiveOrderID),
    )
    if (res && res['receive_order']) {
      const receiveOrder = res['receive_order'];
      if (receiveOrder['receive_order_items'] && Array.isArray(receiveOrder['receive_order_items'])) {
        receiveOrder['receive_order_items'].forEach(item => {
          if (item['receive_order_item'] && item['receive_order_item']['purchase_item'] && item['receive_order_item']['purchase_item']['source_type'] === 'Listing' && item['receive_order_item']['purchase_item']['source_id'] && !listingIDs.includes(item['receive_order_item']['purchase_item']['source_id'])) {
            listingIDs.push(item['receive_order_item']['purchase_item']['source_id']);
            if (ids) {
              ids += `&ids[]=${item['receive_order_item']['purchase_item']['source_id']}`;
            } else {
              ids = `?ids[]=${item['receive_order_item']['purchase_item']['source_id']}`;
            }
          }
        })
      }

      const listingInfo = yield call(
        axios.get,
        Config.urls.getListings.replace('{storeID}', storeID).replace('{ids}', ids),
      );
      if (listingInfo && Array.isArray(listingInfo.listings)) {
        listingInfo.listings.forEach((listing: any) => {
          if (listing['id']) {
            listings[listing['id']] = listing;
          }
        })
      }

      if (receiveOrder['receive_order_items'] && Array.isArray(receiveOrder['receive_order_items'])) {
        receiveOrder['receive_order_items'].forEach(item => {
          if (item['receive_order_item'] && item['receive_order_item']['purchase_item'] && item['receive_order_item']['purchase_item']['source_id']) {
            item['receive_order_item']['purchase_item']['listing'] = listings[item['receive_order_item']['purchase_item']['source_id']]
          }
        })
      }
      returnNote = parseGoodReceivedNote(receiveOrder);
    }
  } catch (error) {
    console.error(error);
  }

  if (callback) {
    callback(returnNote);
  }
}

function* handleCancelReturnNote(params: ICancelReturnNote) {
  const { receiveOrderID, callback, storeID } = params;
  let returnNote: IReceiveOrder | undefined = undefined;
  const listingIDs: string[] = [];
  const listings: {[id: string]: any} = {};
  let ids = '?';
  try {
    const res = yield call(
      axios.put,
      Config.urls.cancelReceiveOrder.replace('{storeID}', storeID).replace('{receiveOrderID}', receiveOrderID),
    )
    if (res && res['receive_order']) {
      const receiveOrder = res['receive_order'];
      if (receiveOrder['receive_order_items'] && Array.isArray(receiveOrder['receive_order_items'])) {
        receiveOrder['receive_order_items'].forEach(item => {
          if (item['receive_order_item'] && item['receive_order_item']['purchase_item'] && item['receive_order_item']['purchase_item']['source_type'] === 'Listing' && item['receive_order_item']['purchase_item']['source_id'] && !listingIDs.includes(item['receive_order_item']['purchase_item']['source_id'])) {
            listingIDs.push(item['receive_order_item']['purchase_item']['source_id']);
            ids += `ids[]=${item['receive_order_item']['purchase_item']['source_id']}&`;
          }
        })
      }

      const listingInfo = yield call(
        axios.get,
        Config.urls.getListings.replace('{storeID}', storeID).replace('{ids}', ids),
      );
      if (listingInfo && Array.isArray(listingInfo.listings)) {
        listingInfo.listings.forEach((listing: any) => {
          if (listing['id']) {
            listings[listing['id']] = listing;
          }
        })
      }

      if (receiveOrder['receive_order_items'] && Array.isArray(receiveOrder['receive_order_items'])) {
        receiveOrder['receive_order_items'].forEach(item => {
          if (item['receive_order_item'] && item['receive_order_item']['purchase_item'] && item['receive_order_item']['purchase_item']['source_id']) {
            item['receive_order_item']['purchase_item']['listing'] = listings[item['receive_order_item']['purchase_item']['source_id']]
          }
        })
      }

      returnNote = parseGoodReceivedNote(receiveOrder);
    }
  } catch (error) {
    console.error(error);
  }

  if (callback) {
    callback(returnNote);
  }
}

function* handleReceiveReturnNote(params: IReceiveReturnNote) {
  const { receiveOrderID, callback, storeID } = params;
  let returnNote: IReceiveOrder | undefined = undefined;
  const listingIDs: string[] = [];
  const listings: {[id: string]: any} = {};
  let ids = '?';
  try {
    const receiveOrders = yield call(
      axios.get,
      Config.urls.getReceiveOrder.replace('{storeID}', storeID).replace('{receiveOrderID}', receiveOrderID),
    )
    if (receiveOrders && receiveOrders['receive_order']) {
      const receiveItems = receiveOrders['receive_order']['receive_order_items'];
      const receiveOrderItems: any[] = [];
      if (Array.isArray(receiveItems)) {
        receiveItems.forEach(item => {
          if (item['receive_order_item']) {
            receiveOrderItems.push(item['receive_order_item'])
          }
        })
      }
      const receiveOrder = {
        'receive_order': receiveOrders['receive_order'],
        'receive_order_items': receiveOrderItems,
      }

      const res = yield axios({
        method: 'PUT',
        url: Config.urls.receiveReceiveOrder.replace('{storeID}', storeID).replace('{receiveOrderID}', receiveOrderID),
        data: receiveOrder,
        headers: {
          'x-user-device-type': 'pos',
        }
      })

      if (res && res['receive_order']) {
        const receiveOrder = res['receive_order'];
        if (receiveOrder['receive_order_items'] && Array.isArray(receiveOrder['receive_order_items'])) {
          receiveOrder['receive_order_items'].forEach(item => {
            if (item['receive_order_item'] && item['receive_order_item']['purchase_item'] && item['receive_order_item']['purchase_item']['source_type'] === 'Listing' && item['receive_order_item']['purchase_item']['source_id'] && !listingIDs.includes(item['receive_order_item']['purchase_item']['source_id'])) {
              listingIDs.push(item['receive_order_item']['purchase_item']['source_id']);
              ids += `ids[]=${item['receive_order_item']['purchase_item']['source_id']}&`;
            }
          })
        }
  
        const listingInfo = yield call(
          axios.get,
          Config.urls.getListings.replace('{storeID}', storeID).replace('{ids}', ids),
        );
        if (listingInfo && Array.isArray(listingInfo.listings)) {
          listingInfo.listings.forEach((listing: any) => {
            if (listing['id']) {
              listings[listing['id']] = listing;
            }
          })
        }
  
        if (receiveOrder['receive_order_items'] && Array.isArray(receiveOrder['receive_order_items'])) {
          receiveOrder['receive_order_items'].forEach(item => {
            if (item['receive_order_item'] && item['receive_order_item']['purchase_item'] && item['receive_order_item']['purchase_item']['source_id']) {
              item['receive_order_item']['purchase_item']['listing'] = listings[item['receive_order_item']['purchase_item']['source_id']]
            }
          })
        }
  
        returnNote = parseGoodReceivedNote(receiveOrder);
      }
    }
  } catch (error) {
    console.error(error);
  }

  if (callback) {
    callback(returnNote);
  }
}

const getReceiveOrderItems = (receiveOrder: IReceiveOrder) => {
  const receiveOrderItems: any[] = [];
  receiveOrder.purchaseOrders.forEach(item => {
    item.lineItems.forEach(lineItem => {
      if (lineItem.receiveOrderItemID) {
        receiveOrderItems.push({
          ...lineItem.purchaseItem,
          'purchase_order_id': lineItem.purchaseOrderID,
          'qty_received': 0,
          'quantity': lineItem.qtyRemaining * lineItem.displayUnitRatio * -1,
          'quantity_in_display_unit': lineItem.qtyRemaining * -1,
          'qty_received_in_display_unit': 0,
          'purchase_item': {
            'name': lineItem.name,
            'purchase_order_id': lineItem.purchaseOrderID,
            'source_id': lineItem.id,
            'id': lineItem.purchaseItemID,
            'source_type': 'Listing',
            'qty_requested': lineItem.qtyPO,
            'quantity_in_display_unit': lineItem.qtyPO,
            'qty_received_in_display_unit': lineItem.qtyReceivedPO,
          },
          'qty_remaining': lineItem.qtyRemaining * lineItem.displayUnitRatio,
          'qty_remaining_in_display_unit': lineItem.qtyRemaining,
          'poquantity': lineItem.qtyPO,
          'qty_fulfilled': lineItem.qtyPO,
          'display_unit_ratio': lineItem.displayUnitRatio,
          'display_unit_id': lineItem.displayUnitID === 0 ? null : lineItem.displayUnitID,
        })
      } else {
        const receiveOrderItem = {
          ...lineItem.purchaseItem,
          'purchase_order_id': lineItem.purchaseOrderID,
          'quantity': lineItem.qtyReceive * lineItem.displayUnitRatio,
          'quantity_in_display_unit': lineItem.qtyReceive,
          'qty_requested': 0,
          'qty_received': 0,
          'qty_received_in_display_unit': 0,
          'purchase_item': {
            'name': lineItem.name,
            'purchase_order_id': lineItem.purchaseOrderID,
            'source_id': lineItem.id
          },
          'purchase_item_id': lineItem.purchaseItem['id'],
          'qty_remaining': lineItem.qtyRemaining * lineItem.displayUnitRatio,
          'qty_remaining_in_display_unit': lineItem.qtyRemaining,
          'display_unit_ratio': lineItem.displayUnitRatio,
          'display_unit_id': lineItem.displayUnitID === 0 ? null : lineItem.displayUnitID,
          'description': lineItem.name,
        }
        delete receiveOrderItem['id'];
        receiveOrderItems.push(receiveOrderItem)
      }
    })
  })

  return receiveOrderItems;
}

function* paySaga() {
  yield takeEvery(ActionType.QUERY_RETURN_NOTES, handleQueryReturnNotes);
  yield takeEvery(ActionType.QUERY_RETURN_NOTE, handleQueryReturnNote);
  yield takeEvery(ActionType.CANCEL_RETURN_NOTE, handleCancelReturnNote);
  yield takeEvery(ActionType.RECEIVE_RETURN_NOTE, handleReceiveReturnNote);
  yield takeEvery(ActionType.CREATE_RETURN_NOTE, handleCreateReturnNote);
}

export default paySaga();
